module.exports = __webpack_public_path__ + "img/all.069f0d74.png";